import React, { Component } from 'react';
import $ from "jquery";
import BasicDetails from '../employeePages/BasicDetails';
import ContactInformation from '../employeePages/ContactInformation';
import IdentityDocuments from '../employeePages/IdentityDocuments';
import EmploymentDetails from '../employeePages/EmploymentDetails';
import PreviousEmploymentDetails from '../employeePages/PreviousEmploymentDetails';
import SalaryCompensationDetails from '../employeePages/SalaryCompensationDetails';
import EducationalQualificationsAndBarDetails from '../employeePages/EducationalQualificationsAndBarDetails';
import StatutoryComplianceInformation from '../employeePages/StatutoryComplianceInformation';
import LeaveAttendanceRecords from '../employeePages/LeaveAttendanceRecords';
import ITSystemAccessInformation from '../employeePages/ITSystemAccessInformation';
import CodeOfConductPoliciesCompliance from '../employeePages/CodeOfConductPoliciesCompliance';
import PerformanceAppraisalDetails from '../employeePages/PerformanceAppraisalDetails';
import ExitFullFinalSettlementRecords from '../employeePages/ExitFullFinalSettlementRecords';
import ForInHouseCounselsEmployee from '../employeePages/ForInHouseCounselsEmployee';
class ProfileView extends Component {

    constructor(props) {
      super(props);
      this.id = this.props.emp_id;
      this.fullname = this.props.fullname;
      this.state = {
        form_type_list : ['Basic Details','Contact Information','Identity & Verification Documents','Employment Details','Educational Qualifications and Bar details','Previous Employment Details','Salary & Compensation Details','Statutory Compliance Information','Leave & Attendance Records','IT & System Access Information','Code of Conduct & Policies Compliance','Performance & Appraisal Details','Exit & Full & Final Settlement Records','For In-House Counsels / employee'],
        form_type_view:[],
        form_view_list:[<BasicDetails page_title="Basic Details" id={this.id} fullname={this.fullname}/>,<ContactInformation page_title="Contact Information" id={this.id}/>,<IdentityDocuments page_title="Identity & Verification Documents" id={this.id}/>,<EmploymentDetails page_title="Employment Details" id={this.id}/>,<EducationalQualificationsAndBarDetails page_title="Educational Qualifications and Bar details" id={this.id}/>,<PreviousEmploymentDetails page_title="Previous Employment Details" id={this.id}/>,<SalaryCompensationDetails page_title="Salary &amp; Compensation Details" id={this.id}/>, <StatutoryComplianceInformation page_title="Statutory Compliance Information" id={this.id}/>,<LeaveAttendanceRecords page_title="Leave &amp; Attendance Records" id={this.id}/>,<ITSystemAccessInformation page_title="IT &amp; System Access Information" id={this.id}/>,<CodeOfConductPoliciesCompliance page_title="Code of Conduct &amp; Policies Compliance" id={this.id}/>,<PerformanceAppraisalDetails page_title='Performance &amp; Appraisal Details' id={this.id}/>,<ExitFullFinalSettlementRecords page_title='Exit &amp; Full &amp; Final Settlement Records' id={this.id}/>, <ForInHouseCounselsEmployee page_title='For In-House Counsels / Employee' id={this.id}/>],
        view_form:'',
        submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.change_emp_password.bind(this)}>Update</button>,
      };
    }

componentDidMount(){
  var form_type_view = [];
  var list = this.state.form_type_list;
  for (var i = 0; i < list.length; i++) {
    var for_name = list[i];
    form_type_view.push(
    <option value={for_name}>{for_name}</option>
    );
  }
  this.setState({form_type_view});
  setTimeout(function (){
    $('#form_type').val(list[0]);
    this.selectionsFormType();
  }.bind(this),100);
}

change_emp_password(){

}


selectionsFormType(){
  var form_type = $('#form_type').val();
  var form_type_list = this.state.form_type_list;
  var form_view_list = this.state.form_view_list;
  var view_form = '';
  if(form_type_list.includes(form_type)){
    view_form = form_view_list[form_type_list.indexOf(form_type)];
  }else {
    view_form = '';
  }
  this.setState({view_form});
}

  render() {
    return (
      <div className="col-md-12 mt-4 mb-4">
      <h3 className="wow fadeInUp" data-wow-delay="0.1s">Details</h3>
          <div className="wow fadeInUp" data-wow-delay="0.5s">
              <form action="" method="post">
                  <div className="row g-3">

                  <div className="col-md-4">
                      <div className="form-floating">
                          <input type="text" className="form-control" id="full_name" placeholder="Full Name" value={this.props.fullname} readOnly="true"/>
                          <label for="name">Full Name</label>
                      </div>
                  </div>
                <div className="col-md-4">
                    <div className="form-floating">
                        <select class="form-control form-select" id="form_type" name="form_type" onChange={this.selectionsFormType.bind(this)}>
                        <option value="">Employee Form Type</option>
                        {this.state.form_type_view}
                    </select>
                    <label for="name">Employee Form Type</label>
                    </div>
                </div>

                <div className="col-md-12">
                  {this.state.view_form}
                </div>

                  </div>
            </form>
          </div>
      </div>
    );
  }
}

export default ProfileView;
